import { useDataChange } from 'Simple/Data.js'

export function useOnClick(props) {
  let change = useDataChange({
    context: 'referrals',
    viewPath: props.viewPath,
  })

  return function onClick() {
    change(next => {
      next.push({})
    })
  }
}
